let _getAccessTokenSilently = null;

export const security = {
  getAccessTokenSilently: () => _getAccessTokenSilently,
  setAccessTokenSilently: (func) => (_getAccessTokenSilently = func),
};

export function canAccessDashboard (dashboard) {
  return dashboard.type === 'powerbi' ? !!dashboard.report_id : !!dashboard.iframe_src;
}
